export default __webpack_public_path__ + "static/media/service.7347902b.png";